import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { Button, Menu, MenuItem, ListItemIcon } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Config/firebase";
import { consultaTenantAtual } from "../../Utils/tenant";

export const CONFIGURACOES_EXPORTACAO = {
  "/app/calibracao-prensa": { titulo: "Calibrações de Prensa", colecoes: ["tblCalibracaoPrensas"] },
  "/app/calibracao-prensa-externa": { titulo: "Calibrações Externas de Prensa", colecoes: ["tblCalibracoesExternasPrensa"] },
  "/app/calibracao-prensa-solos": { titulo: "Calibrações de Prensa de Solos", colecoes: ["tblCalibracaoPrensasSolos"] },
  "/app/ensaio-raa": { titulo: "Ensaios RAA", colecoes: ["tblEnsaioRAA"], ocultarParaCliente: true },
  "/app/extracoes-testemunhos": { titulo: "Extrações de Testemunhos", colecoes: ["tblExtracoesTestemunhos"] },
  "/app/esclerometria": { titulo: "Ensaios de Esclerometria", colecoes: ["tblEsclerometrias"] },
  "/app/resistencia-tracao": { titulo: "Ensaios de Resistência à Tração", colecoes: ["tblEnsaiosTracao"] },
  "/app/ensaio-argamassa": { titulo: "Ensaios de Argamassa", colecoes: ["tblEnsaiosArgamassa"] },
  "/app/modulo-elasticidade": { titulo: "Módulos de Elasticidade", colecoes: ["tblModulosElasticidade"] },
  "/app/relatorios/modulo-elasticidade": { titulo: "Relatórios de Módulo de Elasticidade", colecoes: ["tblRelatoriosModuloElasticidade"] },
  "/app/medicoes": { titulo: "Medições", colecoes: ["tblMedicoes"] },
  "/app/ruptura-paver": { titulo: "Rupturas de Paver", colecoes: ["tblRupturaPavers"] },
  "/app/ruptura-bloco-ceramico": { titulo: "Rupturas de Bloco Cerâmico", colecoes: ["tblRupturaBlocoCeramicos"] },
  "/app/ruptura-bloco-concreto": { titulo: "Rupturas de Bloco de Concreto", colecoes: ["tblRupturaBlocoConcretos"] },
  "/app/ensaio-solo-cimento": { titulo: "Ensaios de Tijolo Solo-Cimento", colecoes: ["tblEnsaiosSoloCimento"] },
  "/app/cadastro-caracterizacao": { titulo: "Caracterizações de Agregados", colecoes: ["tblCaracterizacaoAgregados"] },
  "/app/cimento-consistencia-pega": { titulo: "Ensaios de Cimento, Consistência e Pega", colecoes: ["tblCimentoConsistenciaPega"], ocultarParaCliente: true },
  "/app/ensaio-compactacao": { titulo: "Ensaios de Compactação", colecoes: ["tblEnsaiosCompactacao"] },
  "/app/densidade-in-situ": { titulo: "Ensaios de Densidade in situ", colecoes: ["tblDensidadeInSitu"] },
  "/app/proposta-comercial": { titulo: "Propostas Comerciais", colecoes: ["tblPropostasComerciais"] },
  "/app/cadastro-dosagem": { titulo: "Dosagens de Concreto", colecoes: ["tblDosagensConcreto"] },
  "/app/guias-dosagem": { titulo: "Guias de Dosagem", colecoes: ["tblGuiasDosagem"] },
  "/app/relatorios-visita-tecnica": { titulo: "Relatórios de Visita Técnica", colecoes: ["tblRelatoriosVisitaTecnica"] },
  "/app/adesividade-ligante-betuminoso": { titulo: "Ensaios de Adesividade", colecoes: ["tblAdesividadeLiganteBetuminoso"] },
  "/app/granulometria-asfalto": { titulo: "Granulometrias de Asfalto", colecoes: ["tblGranulometriaAsfalto"] },
  "/app/relatorios/mescla-granulometrica": { titulo: "Mesclas Granulométricas", colecoes: ["tblGranulometriaAsfalto"] },
  "/app/caracterizacao-asfalto": { titulo: "Caracterizações de Agregados para Asfalto", colecoes: ["tblCaracterizacaoAgregadosAsfalto"] },
  "/app/traco-cbuq": { titulo: "Traços CBUQ", colecoes: ["tblTracosCbuq"] },
  "/app/agendamoldagem": {
    titulo: "Agenda de Moldagem e Ruptura",
    colecoes: ["tblAgendaRuptura"],
    subcolecoes: ["caminhoes"],
    transformador: transformarAgendaRuptura,
  },
  "/admin/psicossocial/cadastro": { titulo: "Cadastros Psicossociais", colecoes: ["psicossocial_colaboradores"] },
  "/app/cadastro-equipamentos": {
    titulo: "Equipamentos",
    colecoes: ["equipamentos"],
    relacionadas: [{ colecao: "eq_documentos", chave: "equipamentoId", campo: "documentos" }],
    transformador: transformarEquipamentos,
  },
  "/app/cadastrousuarios": { titulo: "Usuários", colecoes: ["users"] },
  "/app/clientes": { titulo: "Clientes", colecoes: ["clientes"] },
  "/app/cadastroobras": { titulo: "Obras", colecoes: ["obras"] },
  "/app/cadastro-concreteiras": { titulo: "Concreteiras", colecoes: ["concreteiras"] },
  "/app/caixinha-empresa": {
    titulo: "Caixinha da Empresa",
    colecoes: ["tblCaixinhaEmpresa"],
    exportadorPdf: exportarCaixinhaPDF,
  },
  "/app/departamento-pessoal": { titulo: "Departamento Pessoal", colecoes: ["dp_funcionarios", "dp_prestacoes"] },
};

function nomeArquivo(titulo) {
  return String(titulo || "lista-cadastros")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || "lista-cadastros";
}

function valorSimples(valor) {
  if (valor === null || valor === undefined) return "";
  if (valor?.toDate instanceof Function) return valor.toDate().toLocaleString("pt-BR");
  if (valor instanceof Date) return valor.toLocaleString("pt-BR");
  if (typeof valor === "boolean") return valor ? "Sim" : "Não";
  if (typeof valor === "number" || typeof valor === "string") return valor;
  if (valor?.path && typeof valor.path === "string") return valor.path;
  return String(valor);
}

function formatarDataExportacao(valor) {
  if (!valor) return "-";
  if (valor?.toDate instanceof Function) return valor.toDate().toLocaleDateString("pt-BR");
  if (valor instanceof Date) return valor.toLocaleDateString("pt-BR");
  const texto = String(valor);
  const correspondencia = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return correspondencia ? `${correspondencia[3]}/${correspondencia[2]}/${correspondencia[1]}` : texto;
}

function numeroDecimal(valor) {
  if (typeof valor === "number") return valor;
  const texto = String(valor ?? "").trim();
  const normalizado = texto.includes(",")
    ? texto.replace(/\./g, "").replace(",", ".")
    : texto;
  const numero = Number(normalizado);
  return Number.isFinite(numero) ? numero : null;
}

function exportarCaixinhaPDF(registros, configuracao) {
  const moeda = (valor) =>
    Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  const nomeCarteira = (carteira) => (carteira === "cartao" ? "Cartão" : "Dinheiro");
  const nomeMovimento = (registro) => {
    if (registro.tipo !== "entrada") return "Despesa";
    if (registro.tipoEntrada === "saldo_anterior") return "Saldo anterior";
    if (registro.tipoEntrada === "cartao_alimentacao") return "Cartão alimentação";
    return "Depósito";
  };
  const ordenados = registros
    .slice()
    .sort((a, b) => String(a.data || "").localeCompare(String(b.data || "")));
  const totais = ordenados.reduce(
    (resumo, registro) => {
      const valor = numeroDecimal(registro.valor) || 0;
      const carteira = registro.carteira === "cartao" ? "cartao" : "dinheiro";

      if (registro.tipo === "entrada") {
        resumo.entradas += valor;
        resumo[carteira] += valor;
      } else {
        resumo.saidas += valor;
        resumo[carteira] -= valor;
      }
      resumo.saldo += registro.tipo === "entrada" ? valor : -valor;
      return resumo;
    },
    { entradas: 0, saidas: 0, dinheiro: 0, cartao: 0, saldo: 0 }
  );
  let saldoAcumulado = 0;
  const linhas = ordenados.map((registro) => {
    const valor = numeroDecimal(registro.valor) || 0;
    const entrada = registro.tipo === "entrada";
    saldoAcumulado += entrada ? valor : -valor;

    return [
      formatarDataExportacao(registro.data),
      nomeMovimento(registro),
      nomeCarteira(registro.carteira),
      registro.descricao || "-",
      registro.numeroNota || "-",
      entrada ? moeda(valor) : "-",
      entrada ? "-" : moeda(valor),
      moeda(saldoAcumulado),
    ];
  });

  const pdf = new jsPDF("l", "mm", "a4");
  const larguraPagina = pdf.internal.pageSize.getWidth();
  const margem = 10;
  const larguraUtil = larguraPagina - margem * 2;
  const emitidoEm = new Date().toLocaleString("pt-BR");

  pdf.setDrawColor(13, 71, 161);
  pdf.setFillColor(13, 71, 161);
  pdf.rect(margem, 9, larguraUtil, 2, "F");
  pdf.setTextColor(25, 35, 50);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(15);
  pdf.text("RELATÓRIO DO CAIXINHA DA EMPRESA", margem, 18);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(80, 90, 105);
  pdf.text("Controle consolidado de entradas, despesas e saldos por carteira", margem, 23);
  pdf.text(`Emitido em ${emitidoEm} | ${ordenados.length} lançamento(s)`, larguraPagina - margem, 18, { align: "right" });

  const indicadores = [
    ["TOTAL DE ENTRADAS", moeda(totais.entradas), [32, 115, 70]],
    ["TOTAL DE SAÍDAS", moeda(totais.saidas), [183, 28, 28]],
    ["SALDO EM DINHEIRO", moeda(totais.dinheiro), [27, 94, 32]],
    ["SALDO EM CARTÃO", moeda(totais.cartao), [13, 71, 161]],
    ["SALDO GERAL", moeda(totais.saldo), [55, 65, 81]],
  ];
  const espaco = 2;
  const larguraIndicador = (larguraUtil - espaco * (indicadores.length - 1)) / indicadores.length;

  indicadores.forEach(([rotulo, valor, cor], indice) => {
    const x = margem + indice * (larguraIndicador + espaco);
    pdf.setFillColor(247, 249, 252);
    pdf.setDrawColor(210, 217, 226);
    pdf.roundedRect(x, 28, larguraIndicador, 16, 1.5, 1.5, "FD");
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(6.5);
    pdf.setTextColor(90, 100, 115);
    pdf.text(rotulo, x + 3, 33.5);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(9);
    pdf.setTextColor(...cor);
    pdf.text(valor, x + 3, 40);
  });

  const totalPaginas = "{total_paginas_caixinha}";
  autoTable(pdf, {
    head: [["DATA", "MOVIMENTO", "CARTEIRA", "DESCRIÇÃO", "NOTA FISCAL", "ENTRADA", "SAÍDA", "SALDO ACUMULADO"]],
    body: linhas,
    startY: 49,
    margin: { left: margem, right: margem, bottom: 12 },
    theme: "grid",
    styles: {
      fontSize: 7,
      cellPadding: 1.6,
      overflow: "linebreak",
      valign: "middle",
      lineColor: [210, 217, 226],
      lineWidth: 0.15,
    },
    headStyles: {
      fillColor: [13, 71, 161],
      textColor: 255,
      fontStyle: "bold",
      halign: "center",
    },
    alternateRowStyles: { fillColor: [247, 249, 252] },
    columnStyles: {
      0: { cellWidth: 20, halign: "center" },
      1: { cellWidth: 30 },
      2: { cellWidth: 24 },
      3: { cellWidth: 76 },
      4: { cellWidth: 25 },
      5: { cellWidth: 29, halign: "right", textColor: [32, 115, 70] },
      6: { cellWidth: 29, halign: "right", textColor: [183, 28, 28] },
      7: { cellWidth: 34, halign: "right", fontStyle: "bold" },
    },
    didDrawPage: () => {
      const paginaAtual = pdf.internal.getCurrentPageInfo().pageNumber;
      const alturaPagina = pdf.internal.pageSize.getHeight();
      pdf.setDrawColor(210, 217, 226);
      pdf.line(margem, alturaPagina - 8, larguraPagina - margem, alturaPagina - 8);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(7);
      pdf.setTextColor(100, 110, 125);
      pdf.text(configuracao.titulo, margem, alturaPagina - 4.5);
      pdf.text(`Página ${paginaAtual} de ${totalPaginas}`, larguraPagina - margem, alturaPagina - 4.5, { align: "right" });
    },
  });

  if (typeof pdf.putTotalPages === "function") pdf.putTotalPages(totalPaginas);
  pdf.save("relatorio-caixinha-da-empresa.pdf");
}

function resistenciaMpa(cargaTon, areaCp) {
  const carga = numeroDecimal(cargaTon);
  if (!carga) return "-";
  const area = Number(areaCp) || 7854;
  return ((carga * 9806) / area).toFixed(1).replace(".", ",");
}

function tipoConcretoAgenda(tipo) {
  if (tipo === "bombeado") return "Bombeado";
  if (tipo === "convencional") return "Descarga direta";
  if (tipo === "nao_informado") return "N/I";
  return tipo || "-";
}

function transformarEquipamentos(registros) {
  const cabecalhos = [
    "NOME",
    "DESCRIÇÃO",
    "LOCADO",
    "ATIVO",
    "DOCUMENTO DE CALIBRAÇÃO",
    "Nº DO CERTIFICADO",
    "DATA DA CALIBRAÇÃO",
    "VENCIMENTO",
    "ARQUIVO ORIGINAL",
  ];

  const normalizar = (valor) =>
    String(valor || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

  const linhas = registros
    .slice()
    .sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"))
    .map((equipamento) => {
      const status = String(equipamento.statusEquipamento || "").toLowerCase();
      const ativo = equipamento.ativo !== false && !["inativo", "descartado"].includes(status);
      const certificado = ativo
        ? (equipamento.documentos || []).find((documento) => {
            const identificacao = normalizar(
              `${documento.tipoDocumentoCodigo || ""} ${documento.tipoDocumentoNome || ""}`
            );
            return documento.statusDocumento === "ENVIADO" && identificacao.includes("CERTIFICADO");
          })
        : null;

      return [
        equipamento.nome || "-",
        equipamento.descricao || "-",
        equipamento.locado === true ? "Sim" : "Não",
        ativo ? "Sim" : "Não",
        certificado?.tipoDocumentoNome || "-",
        certificado?.numeroCertificado || "-",
        formatarDataExportacao(certificado?.dataReferencia),
        formatarDataExportacao(certificado?.dataVencimento),
        certificado?.nomeArquivoOriginal || "-",
      ];
    });

  return { cabecalhos, linhas };
}

function transformarAgendaRuptura(registros) {
  const quantidadeIdades = Math.max(0, ...registros.map((registro) =>
    Math.max(registro.idades?.length || 0, registro.qtdIdades || 0)
  ));

  const cabecalhos = [
    "CÓDIGO",
    "CLIENTE",
    "OBRA",
    "RESPONSÁVEL PELA PRODUÇÃO DO CONCRETO",
    "CONCRET. ENG.",
    "MOLDADOR (LAB.)",
    "CONCRETEIRA / CONSTRUTORA",
    "MOLDADOR (CONSTR.)",
    "NOME DO TRAÇO",
    "FCK (MPa)",
    "SLUMP TRAÇO",
    "VOL. M³",
    "TIPO DO CONCRETO",
    "DATA",
    "Nº DO C.P.",
    "NOTA FISCAL",
    "SLUMP CAMPO",
  ];

  for (let indice = 0; indice < quantidadeIdades; indice += 1) {
    cabecalhos.push(`IDADE ${indice + 1}`, `CP1 - IDADE ${indice + 1}`, `CP2 - IDADE ${indice + 1}`);
  }
  cabecalhos.push("PEÇA CONCRETADA", "OBSERVAÇÕES");

  const linhas = registros.flatMap((registro) => {
    const caminhoes = registro.caminhoes?.length ? registro.caminhoes : [{}];
    const moldagemLaboratorio = registro.responsavelMoldagem !== "construtora";

    return caminhoes.map((caminhao, indiceCaminhao) => {
      const linha = [
        registro.codigo || registro.cod_obra || "-",
        registro.cliente || "-",
        registro.obra || "-",
        registro.concreteira || "-",
        moldagemLaboratorio ? "X" : "-",
        moldagemLaboratorio ? registro.moldador || "-" : "-",
        moldagemLaboratorio ? "-" : "X",
        moldagemLaboratorio ? "-" : registro.moldador || "-",
        registro.nomeTraco || "-",
        registro.fckProjeto || "-",
        registro.slumpProjeto
          ? `${registro.slumpProjeto}${registro.toleranciaSlumpProjeto ? ` ± ${registro.toleranciaSlumpProjeto}` : ""}`
          : "-",
        numeroDecimal(caminhao.qtd) ?? "-",
        tipoConcretoAgenda(registro.tipoLancamento),
        formatarDataExportacao(registro.datamoldagem),
        caminhao.codigo || caminhao.cod_caminhao || indiceCaminhao + 1,
        caminhao.notaFiscalRomaneio || "-",
        caminhao.slumpObtido ?? "-",
      ];

      for (let indiceIdade = 0; indiceIdade < quantidadeIdades; indiceIdade += 1) {
        const idade = registro.idades?.[indiceIdade];
        const dias = idade?.dias ?? idade ?? "-";
        const resultado = caminhao.resultados?.[indiceIdade] || {};
        linha.push(
          dias === "-" ? "-" : `${dias}${Number.isFinite(Number(dias)) ? " dias" : ""}`,
          resistenciaMpa(resultado.cp1, registro.areaCp),
          resistenciaMpa(resultado.cp2, registro.areaCp)
        );
      }

      linha.push(
        String(caminhao.pecaConcretada || "-").replace(/\n/g, " "),
        String(caminhao.observacoes || registro.observacaoRelatorio || "-").replace(/\n/g, " ")
      );
      return linha;
    });
  });

  return { cabecalhos, linhas };
}

function achatarDados(valor, prefixo = "", resultado = {}) {
  if (Array.isArray(valor)) {
    if (!valor.length && prefixo) resultado[prefixo] = "[]";
    valor.forEach((item, indice) => achatarDados(item, `${prefixo}[${indice}]`, resultado));
    return resultado;
  }

  if (valor && typeof valor === "object" && !(valor instanceof Date) && !(valor?.toDate instanceof Function) && !valor?.path) {
    const entradas = Object.entries(valor);
    if (!entradas.length && prefixo) resultado[prefixo] = "{}";
    entradas.forEach(([chave, item]) => achatarDados(item, prefixo ? `${prefixo}.${chave}` : chave, resultado));
    return resultado;
  }

  if (prefixo) resultado[prefixo] = valorSimples(valor);
  return resultado;
}

async function buscarColecao(nomeColecao) {
  const snapshot = await getDocs(consultaTenantAtual(collection(db, nomeColecao)));
  return snapshot.docs.map((documento) => ({ id: documento.id, ...documento.data() }));
}

async function buscarDadosCompletos(configuracao) {
  const grupos = await Promise.all(
    configuracao.colecoes.map(async (nomeColecao) => {
      const registros = await buscarColecao(nomeColecao);
      return registros.map((registro) => configuracao.colecoes.length > 1
        ? { _colecao: nomeColecao, ...registro }
        : registro);
    })
  );
  const registros = grupos.flat();

  if (configuracao.relacionadas?.length && configuracao.colecoes.length === 1) {
    for (const relacionada of configuracao.relacionadas) {
      const vinculados = await buscarColecao(relacionada.colecao);
      registros.forEach((registro) => {
        registro[relacionada.campo] = vinculados.filter((item) => item[relacionada.chave] === registro.id);
      });
    }
  }

  if (configuracao.subcolecoes?.length && configuracao.colecoes.length === 1) {
    await Promise.all(registros.map(async (registro) => {
      for (const nomeSubcolecao of configuracao.subcolecoes) {
        const snapshot = await getDocs(collection(db, configuracao.colecoes[0], registro.id, nomeSubcolecao));
        registro[nomeSubcolecao] = snapshot.docs.map((documento) => ({ id: documento.id, ...documento.data() }));
      }
    }));
  }

  return registros;
}

export async function exportarListaExcel(configuracao) {
  const registros = await buscarDadosCompletos(configuracao);
  if (!registros.length) throw new Error("Não há registros para exportar.");

  if (configuracao.transformador) {
    const dados = configuracao.transformador(registros);
    const planilha = XLSX.utils.aoa_to_sheet([dados.cabecalhos, ...dados.linhas]);
    planilha["!autofilter"] = { ref: planilha["!ref"] };
    planilha["!freeze"] = { xSplit: 0, ySplit: 1 };
    planilha["!cols"] = dados.cabecalhos.map((cabecalho, indice) => ({
      wch: Math.min(38, Math.max(12, cabecalho.length + 2, ...dados.linhas.map((linha) => String(linha[indice] ?? "").length + 2))),
    }));

    const arquivo = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(arquivo, planilha, "Backup completo");
    XLSX.writeFile(arquivo, `${nomeArquivo(configuracao.titulo)}-completo.xlsx`);
    return;
  }

  const linhas = registros.map((registro) => achatarDados(registro));
  const colunas = Array.from(new Set(linhas.flatMap((linha) => Object.keys(linha))));
  const dadosOrdenados = linhas.map((linha) => Object.fromEntries(colunas.map((coluna) => [coluna, linha[coluna] ?? ""])));
  const planilha = XLSX.utils.json_to_sheet(dadosOrdenados);
  planilha["!cols"] = colunas.map((coluna) => ({
    wch: Math.min(60, Math.max(14, coluna.length + 2, ...dadosOrdenados.map((linha) => String(linha[coluna] || "").length + 2))),
  }));

  const arquivo = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(arquivo, planilha, "Cadastros completos");
  XLSX.writeFile(arquivo, `${nomeArquivo(configuracao.titulo)}-completo.xlsx`);
}

function nomeAbaExcel(titulo, nomesUsados) {
  const base = String(titulo || "Dados")
    .replace(/[\\/?*:[\]]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 31) || "Dados";
  let nome = base;
  let contador = 2;

  while (nomesUsados.has(nome)) {
    const sufixo = ` (${contador})`;
    nome = `${base.slice(0, 31 - sufixo.length)}${sufixo}`;
    contador += 1;
  }

  nomesUsados.add(nome);
  return nome;
}

export async function exportarListasExcel(configuracoes) {
  if (!configuracoes.length) throw new Error("Selecione ao menos um módulo para exportar.");

  const arquivo = XLSX.utils.book_new();
  const nomesUsados = new Set();
  const falhas = [];

  for (const configuracao of configuracoes) {
    try {
      const registros = await buscarDadosCompletos(configuracao);
      let planilha;

      if (!registros.length) {
        planilha = XLSX.utils.aoa_to_sheet([
          [configuracao.titulo],
          ["Nenhum registro encontrado para a empresa atual."],
        ]);
        planilha["!cols"] = [{ wch: 52 }];
      } else if (configuracao.transformador) {
        const dados = configuracao.transformador(registros);
        planilha = XLSX.utils.aoa_to_sheet([dados.cabecalhos, ...dados.linhas]);
        planilha["!autofilter"] = { ref: planilha["!ref"] };
        planilha["!freeze"] = { xSplit: 0, ySplit: 1 };
        planilha["!cols"] = dados.cabecalhos.map((cabecalho, indice) => ({
          wch: Math.min(38, Math.max(12, cabecalho.length + 2, ...dados.linhas.map((linha) => String(linha[indice] ?? "").length + 2))),
        }));
      } else {
        const linhas = registros.map((registro) => achatarDados(registro));
        const colunas = Array.from(new Set(linhas.flatMap((linha) => Object.keys(linha))));
        const dadosOrdenados = linhas.map((linha) => Object.fromEntries(colunas.map((coluna) => [coluna, linha[coluna] ?? ""])));
        planilha = XLSX.utils.json_to_sheet(dadosOrdenados);
        planilha["!cols"] = colunas.map((coluna) => ({
          wch: Math.min(60, Math.max(14, coluna.length + 2, ...dadosOrdenados.map((linha) => String(linha[coluna] || "").length + 2))),
        }));
      }

      XLSX.utils.book_append_sheet(
        arquivo,
        planilha,
        nomeAbaExcel(configuracao.titulo, nomesUsados)
      );
    } catch (error) {
      console.error(`Erro ao exportar o módulo ${configuracao.titulo}:`, error);
      falhas.push({
        titulo: configuracao.titulo,
        motivo: error?.code === "permission-denied" || String(error?.message || "").includes("permission")
          ? "Sem permissão de leitura nas regras do Firestore."
          : error?.message || "Não foi possível consultar os dados.",
      });
    }
  }

  if (!arquivo.SheetNames.length) {
    const modulos = falhas.map((item) => item.titulo).join(", ");
    throw new Error(`Nenhum módulo pôde ser exportado. Verifique as permissões de: ${modulos}`);
  }

  if (falhas.length) {
    const planilhaAvisos = XLSX.utils.json_to_sheet(
      falhas.map((item) => ({ MÓDULO: item.titulo, MOTIVO: item.motivo }))
    );
    planilhaAvisos["!cols"] = [{ wch: 42 }, { wch: 58 }];
    XLSX.utils.book_append_sheet(arquivo, planilhaAvisos, nomeAbaExcel("Avisos", nomesUsados));
  }

  const data = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(arquivo, `exportacao-dados-${data}.xlsx`);
  return {
    exportados: configuracoes.length - falhas.length,
    falhas,
  };
}

async function exportarListaPDF(configuracao) {
  const registros = await buscarDadosCompletos(configuracao);
  if (!registros.length) throw new Error("Não há registros para exportar.");

  if (configuracao.exportadorPdf) {
    configuracao.exportadorPdf(registros, configuracao);
    return;
  }

  if (configuracao.transformador) {
    const dados = configuracao.transformador(registros);
    const pdfTabela = new jsPDF("l", "mm", "a3");
    pdfTabela.setFontSize(14);
    pdfTabela.text(configuracao.titulo, 10, 11);
    pdfTabela.setFontSize(7);
    pdfTabela.text(`${dados.linhas.length} linha(s) — exportado em ${new Date().toLocaleString("pt-BR")}`, 10, 16);
    autoTable(pdfTabela, {
      head: [dados.cabecalhos],
      body: dados.linhas,
      startY: 20,
      theme: "grid",
      styles: { fontSize: 5.5, cellPadding: 1, overflow: "linebreak", halign: "center" },
      headStyles: { fillColor: [176, 193, 216], textColor: 17, fontStyle: "bold" },
      didParseCell: (contexto) => {
        if (contexto.section === "body" && [1, 2, 3, 8, dados.cabecalhos.length - 2, dados.cabecalhos.length - 1].includes(contexto.column.index)) {
          contexto.cell.styles.halign = "left";
        }
      },
    });
    pdfTabela.save(`${nomeArquivo(configuracao.titulo)}-completo.pdf`);
    return;
  }

  const pdf = new jsPDF("p", "mm", "a4");
  pdf.setFontSize(14);
  pdf.text(configuracao.titulo, 14, 15);
  pdf.setFontSize(8);
  pdf.text(`${registros.length} registro(s) — exportado em ${new Date().toLocaleString("pt-BR")}`, 14, 21);

  registros.forEach((registro, indice) => {
    if (indice > 0) pdf.addPage();
    const dados = achatarDados(registro);
    pdf.setFontSize(11);
    pdf.text(`Registro ${indice + 1} — ${registro.codigo || registro.nome || registro.id}`, 14, indice > 0 ? 15 : 29);
    autoTable(pdf, {
      head: [["Campo", "Valor"]],
      body: Object.entries(dados).map(([campo, valor]) => [campo, String(valor ?? "")]),
      startY: indice > 0 ? 20 : 34,
      theme: "grid",
      styles: { fontSize: 7, cellPadding: 1.5, overflow: "linebreak" },
      columnStyles: { 0: { cellWidth: 62, fontStyle: "bold" }, 1: { cellWidth: 116 } },
      headStyles: { fillColor: [13, 71, 161], textColor: 255, fontStyle: "bold" },
    });
  });

  pdf.save(`${nomeArquivo(configuracao.titulo)}-completo.pdf`);
}

export function BotaoExportarLista({ onExcel, onPdf }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportando, setExportando] = useState(false);

  const executar = async (funcao) => {
    setAnchorEl(null);
    setExportando(true);
    try {
      await funcao();
    } catch (error) {
      console.error("Erro ao exportar cadastro:", error);
      window.alert(error?.message || "Não foi possível exportar os dados.");
    } finally {
      setExportando(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        disabled={exportando}
        sx={{ whiteSpace: "nowrap", minWidth: 120, height: 40 }}
      >
        {exportando ? "Exportando..." : "Exportar"}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => executar(onPdf)}>
          <ListItemIcon><PictureAsPdfOutlinedIcon color="error" fontSize="small" /></ListItemIcon>
          PDF
        </MenuItem>
        <MenuItem onClick={() => executar(onExcel)}>
          <ListItemIcon><GridOnOutlinedIcon color="success" fontSize="small" /></ListItemIcon>
          Excel
        </MenuItem>
      </Menu>
    </>
  );
}

export default function ExportarListaAtual() {
  const location = useLocation();
  const [destino, setDestino] = useState(null);
  const configuracao = CONFIGURACOES_EXPORTACAO[location.pathname];
  const clienteLogado = String(localStorage.getItem("tipoUsuario") || "").toLowerCase() === "cliente";

  useEffect(() => {
    const localizarCabecalho = () => {
      if (!configuracao) {
        setDestino(null);
        return;
      }
      const cabecalho = document.querySelector(".cabecalho-lista-cadastro, .cabecalho-exportar-lista");
      const areaBotoes = cabecalho?.classList.contains("cabecalho-exportar-lista")
        ? cabecalho.querySelector(":scope > .MuiStack-root")
        : null;
      setDestino(areaBotoes || cabecalho);
    };

    localizarCabecalho();
    const observer = new MutationObserver(localizarCabecalho);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [configuracao, location.pathname]);

  if (!destino || (configuracao?.ocultarParaCliente && clienteLogado)) return null;

  const dentroDoCabecalhoComBotoes = Boolean(destino.closest(".cabecalho-exportar-lista"));

  return createPortal(
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: dentroDoCabecalhoComBotoes ? 0 : 12 }}>
      <BotaoExportarLista
        onExcel={() => exportarListaExcel(configuracao)}
        onPdf={() => exportarListaPDF(configuracao)}
      />
    </div>,
    destino
  );
}
